<template>
  <div id="app">
    <!-- 路由页面渲染出口（必须有！） -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 简单样式 */
/* #app {
  padding: 10px;
} */
</style>